let audioContext = null;

function getAudioContext() {
    if (!audioContext) {
        const AudioCtx = window.AudioContext || window.webkitAudioContext;
        audioContext = new AudioCtx();
    }
    return audioContext;
}

function playTone(freq, duration = 0.1, type = "sine", volume = 0.08) {
    try {
        const ctx = getAudioContext();
        const oscillator = ctx.createOscillator();
        const gain = ctx.createGain();

        oscillator.type = type;
        oscillator.frequency.value = freq;
        gain.gain.value = volume;

        oscillator.connect(gain);
        gain.connect(ctx.destination);

        oscillator.start();
        gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + duration);
        oscillator.stop(ctx.currentTime + duration);
    } catch (err) {
        // Silent fail for unsupported browsers
    }
}

/* ==================== BASIC SOUNDS ==================== */

export const playTap = () => playTone(550, 0.05, "triangle");

export const playCorrect = () => {
    playTone(650, 0.07);
    setTimeout(() => playTone(850, 0.08), 60);
};

export const playWrong = () => playTone(240, 0.15, "sawtooth");

export const playButton = () => playTone(450, 0.03);
export const playHover = () => playTone(720, 0.02);
export const playStart = () => {
    playTone(500, 0.05);
    setTimeout(() => playTone(700, 0.05), 60);
    setTimeout(() => playTone(900, 0.10), 120);
};

/* ==================== GAMEPLAY SOUNDS ==================== */

export const playCombo = (combo) => {
    const base = 700 + combo * 40;
    playTone(base, 0.05);
    setTimeout(() => playTone(base + 120, 0.05), 40);
    setTimeout(() => playTone(base + 240, 0.06), 80);
};

export const playGolden = () => {
    playTone(900, 0.05);
    setTimeout(() => playTone(1200, 0.05), 50);
    setTimeout(() => playTone(1500, 0.10), 100);
};

export const playTreasure = () => {
    playTone(550, 0.08);
    setTimeout(() => playTone(750, 0.08), 70);
    setTimeout(() => playTone(1000, 0.08), 140);
    setTimeout(() => playTone(1450, 0.12), 210);
};

export const playFreeze = () => playTone(420, 0.20, "triangle");

export const playLevelUp = () => {
    playTone(500, 0.05);
    setTimeout(() => playTone(700, 0.05), 60);
    setTimeout(() => playTone(900, 0.05), 120);
    setTimeout(() => playTone(1200, 0.12), 180);
};

/* ==================== END GAME SOUNDS ==================== */

export const playGameOver = () => {
    playTone(500, 0.12);
    setTimeout(() => playTone(380, 0.15), 120);
    setTimeout(() => playTone(220, 0.20), 260);
};

export const playWin = () => {
    const notes = [523, 659, 784, 1046];
    notes.forEach((n, i) => setTimeout(() => playTone(n, 0.12), i * 90));
};

export const playVictory = () => {
    const notes = [523, 659, 784, 1046, 1318, 1568];
    notes.forEach((note, index) =>
        setTimeout(() => playTone(note, 0.12), index * 90)
    );
};

export const playBonus = () => {
    playTone(900, 0.04);
    setTimeout(() => playTone(1100, 0.04), 35);
    setTimeout(() => playTone(1400, 0.07), 70);
};